<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Delete Users</h1>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <!-- Customers -->
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <h4 class="card-title mb-3">Customers</h4>

            <div class="table-responsive">
              <table
                id="users_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.user.name }}</td>
                    <td>{{ user.user.email }}</td>
                    <td>
                      <button
                        @click="deleteCustomer(user.user_id)"
                        class="btn btn-info btn-rounded btn-block"
                        style="background-color: red; border-color: red;"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Staffs -->
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <h4 class="card-title mb-3">Staffs</h4>

            <div class="table-responsive">
              <table
                id="staffs_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in staffs" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.user.name }}</td>
                    <td>{{ user.user.email }}</td>
                    <td>
                      <button
                        @click="deleteCustomer(user.user_id)"
                        class="btn btn-info btn-rounded btn-block"
                        style="background-color: red; border-color: red;"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "delete-users",
  components: {},

  data() {
    return {
      users: [
        {
          user: [{ name: "", email: "" }]
        },
        { position: "" }
      ],

      staffs: [
        {
          user: [{ name: "", email: "" }]
        },
        { position: "" }
      ]
    };
  },

  methods: {
    loadCustomers() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/customers/all", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.users = res.data;
          });
      }
    },

    loadStaffs() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/staffs/all", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.staffs = res.data;
          });
      }
    },

    deleteCustomer(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .delete("/customers/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            if (res.data.authorised === false) {
              swal({
                icon: "error",
                text: res.data.message
              });
            } else {
              if (res.data.success === true) {
                swal({
                  icon: "success",
                  text: res.data.message
                }).then(ok => {
                  this.loadCustomers();
                });
              } else {
                swal({
                  icon: "error",
                  text: res.data.message
                });
              }
            }
          });
      }
    }
  },

  mounted() {
    this.loadCustomers();
    this.loadStaffs();
    setTimeout(function() {
      $("#users_tbl").DataTable({
        iDisplayLength: 10,
        aLengthMenu: [[10, 15, 30, 50], [10, 15, 30, 50]]
      });

      $("#staffs_tbl").DataTable({
        iDisplayLength: 10,
        aLengthMenu: [[10, 15, 30, 50], [10, 15, 30, 50]]
      });
    }, 2000);
  }
};
</script>
